import React from 'react';
import {
  TableCell,
  TableRow
} from '@material-ui/core';
import { TextFormattedNumber } from 'components';
import { convertUTCDateToLocalDate } from 'helpers/date';
import DateFormat from './DateFormat';


const CustomerGiftCardsRow = ({transaction}) => {
  const {
    transaction_id,
    balance,
    amount,
    created_at,
    comment,
    action_label,
    action_detail
  } = transaction;

  const date = convertUTCDateToLocalDate(created_at);

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
      >
        <TableCell>
          <strong className="px-5">{transaction_id}</strong>
        </TableCell>
        <TableCell>
          <DateFormat date={date} />
        </TableCell>
        <TableCell>{action_label}</TableCell>
        <TableCell>
          <TextFormattedNumber
            value={balance}
            prefix="$"
          />
        </TableCell>
        <TableCell>
          <TextFormattedNumber
            value={amount}
            prefix="$"
          />
        </TableCell>
        <TableCell>{action_detail}</TableCell>
        <TableCell>{comment}</TableCell>
      </TableRow>
    </>
  );
};

export default CustomerGiftCardsRow;
